const invertedMessages = {
  'Please select the correct option from the list.':
    'certs.select.correct.option',
};

export default invertedMessages;
